<template>
  <div class="container-fluid">
    <breadcrumb textItem="Detalhes do Registro" />
    <div class="card border-left-theme shadow mb-5">
      <div class="card-body">
        <details-registry :registryId="registryId" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/commons/Breadcrumb.vue'
import DetailsRegistry from '@/components/registries/DetailsRegistry.vue'

export default {
  name: 'Details',

  components: {
    Breadcrumb,
    DetailsRegistry,
  },

  data() {
    return {
      registryId: this.$route.params.registryId,
    }
  },
}
</script>
